// extracted by mini-css-extract-plugin
module.exports = {"promotedCard":"promoted-page-module--promotedCard--1NMG9","promotedBody":"promoted-page-module--promotedBody--2KKCn","promotedTitle":"promoted-page-module--promotedTitle--3GQO5"};